import React from "react";

type PuzzleLine = {
  cipher: string;
  key: string;
  answer: string;
  value: string;
  status: "idle" | "active" | "wrong" | "correct";
};

type RenderTableType3Props = {
  lines: PuzzleLine[];
  setLines: (lines: PuzzleLine[]) => void;
  activeLine: number;
  setActiveLine: React.Dispatch<React.SetStateAction<number>>;
  checkAnswer: (index: number) => void;
  isGameStarted: boolean;
};

const RenderTableType3: React.FC<RenderTableType3Props> = ({
  lines,
  activeLine,
  setLines,
  setActiveLine,
  checkAnswer,
  isGameStarted,
}) => {
  return (
    <div className="tableS-table--Type3">
      <div className="tableS-header--Type3">Шифр</div>
      <div className="tableS-header--Type3">Ключ</div>
      <div className="tableS-header--Type3">Ответ</div>
      <div className="tableS-header--Type3"></div>

      {lines.map((line, index) => (
        <React.Fragment key={index}>
          <div
            className={`tableS-cell--Type3`}
          >
            {isGameStarted && index <= activeLine ? line.cipher : ""}
          </div>

          <div className={`tableS-cell--Type3`}>
            {isGameStarted && index <= activeLine ? line.key : ""}
          </div>

          <input
            className={`tableS-input--Type3 tableS-${line.status}--Type3 ${
              line.status === "correct" ? "tableS-correct--Type3" : ""
            }`}
            value={line.value}
            disabled={
              !isGameStarted ||
              index !== activeLine ||
              line.status === "correct"
            }
            onFocus={() => {
              const copy = [...lines];
              copy[index].status = "active";
              setLines(copy);
              setActiveLine(index);
            }}
            onBlur={() => {
              const copy = [...lines];

              if (copy[index].status === "active") {
                copy[index].status = "idle";
                setLines(copy);
              }
            }}
            onChange={(e) => {
              const copy = [...lines];
              copy[index].value = e.target.value;

              if (copy[index].status !== "correct") {
                copy[index].status = "active";
              }

              setLines(copy);
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter" && !event.repeat) {
                event.preventDefault();
                checkAnswer(index);
                event.currentTarget.blur();
              }
            }}
          />

          <div
            className={`tableS-check--Type3`}
          >
            {index === activeLine && line.status === "active" && (
              <img
                src="/img/transpos/check_1.svg"
                alt="Проверить"
                className="tableS-icon----Type3"
                onMouseDown={() => checkAnswer(index)}
              />
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default RenderTableType3;
